import { Field, FieldType } from "../types";
import React from "react";
import { EmailAutocomplete } from "./EmailAutocomplete";
import { Text } from "./Text";
import { RadioGroup } from "@kaltura/mediaspace-shared-ui";

export const FormField = (field: Field) => {
    const { type } = field;

    switch (type) {
        case FieldType.TEXT:
            return <Text field={field} />;
        case FieldType.RADIO: {
            return <RadioGroup {...field} />;
        }
        case FieldType.EMAIL_AUTOCOMPLETE: {
            return <EmailAutocomplete field={field} />;
        }
        default:
            return null;
    }
};
